import translations from './translations.js';

translations.components.timepicker.hours = 'HH';
translations.components.timepicker.minutes = 'MM';

export default {
  dateFormat: 'm-d-Y',
  timeFormat: 'H:i:s',
  language: 'en',
  translations
};
